import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { EditorModule } from '@tinymce/tinymce-angular';
import { MaxBrainSharedModule } from 'app/projects/shared/src/lib/shared.module';
import { NgxCleaveDirectiveModule } from 'ngx-cleave-directive';
import { EngageNewPostingDialogComponent } from './components/dialogs/engage-new-posting-dialog/engage-new-posting-dialog.component';
import { GrowArticleNewPostingDialogComponent } from './components/dialogs/grow-article-new-posting-dialog/grow-article-new-posting-dialog.component';
import { PostingTypeApiService } from './services/posting-type.api-service';
import { PostingApiService } from './services/posting.api-service';
import { SelectPostingsListComponent } from './components/select-posting-list/list.component';
import { EngageCategoryTreeComponent } from './components/engage-category-tree-page/engage-category-tree-page.component';
import { MatTreeModule } from '@angular/material/tree';
import { CourseCatalogModule } from '../course-catalog/course-catalog.module';
import { MatChipsModule } from '@angular/material/chips';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { SelectPostingPageComponent } from './components/select-posting-page/select-posting-page.component';
import { CategorySingleCardPageComponent } from './components/category-single-card-page/category-single-card-page.component';

@NgModule({
    declarations: [
        EngageNewPostingDialogComponent,
        GrowArticleNewPostingDialogComponent,
        SelectPostingPageComponent,
        SelectPostingsListComponent,
        EngageCategoryTreeComponent,
        CategorySingleCardPageComponent,
    ],
    exports: [SelectPostingPageComponent, SelectPostingsListComponent, EngageCategoryTreeComponent, CategorySingleCardPageComponent],
    imports: [
        MatToolbarModule,
        MatSidenavModule,
        MatMenuModule,
        MatIconModule,
        MatButtonModule,
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        MatTooltipModule,
        MatDialogModule,
        FormsModule,
        MatProgressSpinnerModule,
        MatCheckboxModule,
        MatTableModule,
        MatSortModule,
        MatPaginatorModule,
        MatSelectModule,
        RouterModule,
        MaxBrainSharedModule,
        NgxCleaveDirectiveModule,
        MatDatepickerModule,
        EditorModule,
        MatTreeModule,
        MatChipsModule,
        CourseCatalogModule,
        MatProgressBarModule,
    ],
    providers: [PostingTypeApiService],
})
export class PostingModule {
    static forRoot(): ModuleWithProviders<PostingModule> {
        return {
            ngModule: PostingModule,
            providers: [PostingApiService],
        };
    }
}
